import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import TitleSubtitle from "../../../components/common/TitleSubtitle";
import SoundLibraryList from "./SoundLibraryEditableList";
import TypesManagement from "./TypesManagement";
import CategoriesManagement from "./CategoriesManagement";
import styles from "./SoundLibraryAdmin.module.css";
import studio from "../../../styles/studioPage.module.css";
import adminSurface from "../../../components/layouts/AdminSurface.module.css";

const SoundLibraryManagement: React.FC = () => {
    const { t: rawT } = useTranslation();
    const t = rawT as any;

    const [activeTab, setActiveTab] = useState<"sounds" | "types" | "categories">("sounds");

    const handleTabClick = (tab: "sounds" | "types" | "categories") => {
        setActiveTab(tab);
    };

    return (
        <div className={`${adminSurface.pageContent} ${styles.managementPage}`}>
            <div className={`${studio.pageTitle} ${adminSurface.pageTitle}`}>
                <TitleSubtitle title={t("soundLibrary")} subtitle={t("soundLibraryManagementSubtitle")} />
            </div>

            <div className={styles.tabs}>
                <div
                    className={`${styles.tab}${activeTab === "sounds" ? ` ${styles.tabActive}` : ""}`}
                    onClick={() => handleTabClick("sounds")}
                >
                    {t("sounds")}
                </div>
                <div
                    className={`${styles.tab}${activeTab === "types" ? ` ${styles.tabActive}` : ""}`}
                    onClick={() => handleTabClick("types")}
                >
                    {t("soundTypes")}
                </div>
                <div
                    className={`${styles.tab}${activeTab === "categories" ? ` ${styles.tabActive}` : ""}`}
                    onClick={() => handleTabClick("categories")}
                >
                    {t("soundCategories")}
                </div>
            </div>

            {activeTab === "sounds" && <SoundLibraryList />}
            {activeTab === "types" && <TypesManagement />}
            {activeTab === "categories" && <CategoriesManagement />}
        </div>
    );
};

export default SoundLibraryManagement;
